/**
 * Adjusts submenu position to prevent overflow off screen
 */
class SubmenuPositionAdjuster {
  constructor() {
    this.init();
  }

  init() {
    // Run on load
    this.adjustSubmenus();

    // Run on window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.adjustSubmenus();
      }, 250);
    });

    // Observe DOM changes for dynamic content
    const observer = new MutationObserver(() => {
      this.adjustSubmenus();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  adjustSubmenus() {
    // Select all dropdown menus (first level and nested)
    const submenus = document.querySelectorAll('.list-menu--disclosure, .header__submenu');

    submenus.forEach(submenu => {
      // Reset class first
      submenu.classList.remove('list-menu--disclosure-left');

      // Check if submenu is visible (parent is being hovered)
      const parent = submenu.parentElement;
      if (!parent) return;

      // Add temporary visibility to measure
      const originalDisplay = submenu.style.display;
      const originalVisibility = submenu.style.visibility;
      const originalOpacity = submenu.style.opacity;

      submenu.style.display = 'block';
      submenu.style.visibility = 'hidden';
      submenu.style.opacity = '0';

      // Get submenu position
      const rect = submenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Check if submenu overflows on the right
      if (rect.right > viewportWidth) {
        submenu.classList.add('list-menu--disclosure-left');
      }

      // Restore original styles
      submenu.style.display = originalDisplay;
      submenu.style.visibility = originalVisibility;
      submenu.style.opacity = originalOpacity;
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SubmenuPositionAdjuster();
  });
} else {
  new SubmenuPositionAdjuster();
}
